'use strict';

export default class Accordion {
    constructor() {
        this.block = $(".paragraph--type--accordion");
    }
    
    init() {
        $(".paragraph--type--accordion").each(function () {
            const accordion = $(this);
            const triggers = accordion.find(".accordion-trigger");
            triggers.each(function (index) {
                const trigger = $(this);
                const content = trigger.next(".accordion-content");
                // Set ARIA attributes
                trigger.attr({
                    'tabindex': 0,
                    'role': 'button',
                    'aria-expanded': 'false',
                    'aria-controls': `accordion-content-${index}`
                });
                content.attr({
                    'id': `accordion-content-${index}`,
                    'role': 'region',
                    'aria-hidden': 'true'
                });
                // Handle click and keydown events
                trigger.on("click keydown", function (e) {
                    if (e.type === "click" || e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        const accordionItem = trigger.closest(".accordion-item");
                        const isExpanded = trigger.attr('aria-expanded') === 'true';
                        trigger.attr('aria-expanded', !isExpanded);
                        content.attr('aria-hidden', isExpanded);
                        accordionItem.toggleClass("active");
                        content.slideToggle();
                    }
                });
            });
        });
    }
    //Expand all functionality
    expand() {
        $(".paragraph--type--accordion .field--name-field-expand-all").on("click keydown", function (e) {
            if (e.type === "click" || e.key === "Enter" || e.key === " ") {
                const accordion = $(this).closest('.paragraph--type--accordion');
                const content = accordion.find(".accordion-content");
                const accordionItem = accordion.find(".accordion-item");
                const trigger = accordion.find(".accordion-trigger");
                
                const anyClosed = trigger.filter('[aria-expanded="false"]').length > 0;
                if (anyClosed) {
                    // Expand all
                    accordionItem.addClass('active');
                    $(this).text('Collpase all');
                    $(this).addClass('active');
                    trigger.attr('aria-expanded', 'true').addClass('active');
                    content.attr('aria-hidden', 'false').stop(true, true).slideDown();
                } else {
                    // Collapse all
                    accordionItem.removeClass('active');
                    $(this).text('Expand all');
                    $(this).removeClass('active');
                    trigger.attr('aria-expanded', 'false').removeClass('active');
                    content.attr('aria-hidden', 'true').stop(true, true).slideUp();
                }
            }
        })
    }
}